import { Directive, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[showLoadingSpinner]',
  standalone: false,
})
export class WithSpinnerDirective {
  @Input() set showLoadingSpinner(isLoading: boolean) {
    this.toggle(isLoading);
  }

  private spinnerDiv: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.createSpinner();
  }

  createSpinner(): void {
    let inlineTypes = 'BUTTON,IMG,INPUT,SELECT,SPAN,';

    if (inlineTypes.indexOf(this.el.nativeElement.tagName) >= 0) {
      this.buildForInline();
    } else {
      this.buildForBlock();
    }
  }

  private buildForInline() {
    /*
    Right now, the only difference between inline and block spinner construction is that 
    block gets 100% width and inline just inherits. Things may need some adjustment as
    we go, though.
    */

    const hostElement = this.el.nativeElement;

    const wrapperDiv = this.renderer.createElement('div');
    this.renderer.setAttribute(wrapperDiv, 'class', 'spinner-container');

    this.renderer.insertBefore(
      this.el.nativeElement.parentNode,
      wrapperDiv,
      this.el.nativeElement,
    );
    this.renderer.appendChild(wrapperDiv, this.el.nativeElement);

    this.spinnerDiv = this.renderer.createElement('div');
    if (this.spinnerDiv) {
      this.renderer.setAttribute(
        this.spinnerDiv,
        'class',
        'spinner-overlay active',
      );
      this.spinnerDiv.setAttribute('hidden', '{{isLoading}}');

      this.renderer.appendChild(wrapperDiv, this.spinnerDiv);

      // Move all child nodes into the new div
      while (hostElement.firstChild) {
        this.renderer.appendChild(wrapperDiv, hostElement.firstChild);
      }
    }
  }

  private buildForBlock() {
    const hostElement = this.el.nativeElement;

    const wrapperDiv = this.renderer.createElement('div');
    this.renderer.setAttribute(wrapperDiv, 'class', 'spinner-container');
    this.renderer.setStyle(wrapperDiv, 'width', '100%');

    this.renderer.insertBefore(
      this.el.nativeElement.parentNode,
      wrapperDiv,
      this.el.nativeElement,
    );
    this.renderer.appendChild(wrapperDiv, this.el.nativeElement);

    this.spinnerDiv = this.renderer.createElement('div');
    if (this.spinnerDiv) {
      this.renderer.setAttribute(
        this.spinnerDiv,
        'class',
        'spinner-overlay active',
      );
      this.spinnerDiv.setAttribute('hidden', '{{isLoading}}');
      this.spinnerDiv.setAttribute(
        'style',
        'background-color: rgba(255, 255, 255, 0);',
      );

      this.renderer.appendChild(wrapperDiv, this.spinnerDiv);

      // Move all child nodes into the new div
      while (hostElement.firstChild) {
        this.renderer.appendChild(wrapperDiv, hostElement.firstChild);
      }
    }
  }

  toggle(isLoading: boolean): void {
    if (this.spinnerDiv) {
      this.renderer.setProperty(this.spinnerDiv, 'hidden', !isLoading);
    }
  }
}
